export class User {
  identifier: string;
  firstName: string;
  lastName: string;
  email: string;
  role: string;
  clientId: string;
  enabled: boolean;
}
